import React, { useEffect } from "react";
import api from "../lib/api";

export const AdCard = ({ ad }) => {
  useEffect(() => {
    if (ad?.id) api.post(`/ads/${ad.id}/impression`).catch(() => {});
  }, [ad?.id]);

  if (!ad) return null;

  return (
    <a
      href={ad.link_url || "#"}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`ad-card-${ad.id}`}
      className="block bg-white rounded-2xl border border-stone-border shadow-sm overflow-hidden hover:shadow-md hover:-translate-y-0.5 transition-all"
    >
      <div className="relative">
        {ad.image_url && (
          <img src={ad.image_url} alt={ad.title} className="w-full h-40 object-cover" />
        )}
        <span className="absolute top-2 left-2 text-[10px] font-semibold uppercase tracking-wide bg-black/60 text-white px-2 py-0.5 rounded-full">
          Ad
        </span>
      </div>
      <div className="p-4">
        <h4 className="font-heading font-semibold text-stone-text">{ad.title}</h4>
        {ad.subtitle && <p className="text-sm text-stone-muted">{ad.subtitle}</p>}
      </div>
    </a>
  );
};
